module.exports = __webpack_public_path__ + "static/media/rugby.bf0bf08b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/rugby.svg
// module id = 396
// module chunks = 7